import LoadingStrip from '@/components/ui/LoadinStrip';
import { setUser } from '@/redux/feature/auth/authSlice';
import { useAppDispatch } from '@/redux/hooks/hooks';
import { VerifyToken } from '@/utils/verifyToken';
import React, { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from 'react-router-dom';

  
  const VerifyAccountByGoogle = ({onNext}:{onNext: () => void;}) => {
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);
    // const [hasToastShown, setHasToastShown] = useState(false);
    const hasToastShown = useRef(false);
    const [hasProcessed, setHasProcessed] = useState(false);
  
    const accessToken = searchParams.get("accessToken");
    useEffect(() => {
      if (!accessToken || hasProcessed) {
        if (!accessToken) {
          toast.error("Google Log In Failed");
        }
        setIsLoading(false);
        navigate("/auth/sign-up?step=1");
        return;
      }
  
      setHasProcessed(true);
      const timer = setTimeout(() => {
        try {
          const user = VerifyToken(accessToken as string);
          dispatch(setUser({ user: user, token: accessToken as string }));
          const newUrl = window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);
          onNext(); 
          setIsLoading(false);
        } catch (error) {
          toast.error("Invalid Access Token");
          navigate("/auth/sign-up?step=1");
        } finally {
          setIsLoading(false);
        }
      }, 2000);
  
      return () => clearTimeout(timer);
    }, [accessToken]);

    
  return (
    <div className="bg-white h-[300px] flex justify-center items-center border border-[#D0D5DD] rounded-xl p-6 max-w-[504px] mx-auto">
    {isLoading ? (
      <div className="text-center w-[200px] space-y-2">
        <p className="text-[16px] font-medium animate-pulse pb-2">
          Verifying...
        </p>
        <LoadingStrip />
      </div>
    ) : (
      <p className="text-[16px] font-semibold">Done</p>
    )}
  </div>
  )
}

export default VerifyAccountByGoogle